import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class TimeToolSyncGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var timeToolSyncGrid = this;
		setTimeout(function(){
			timeToolSyncGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var timeToolSyncGrid = this;
		
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			return UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];

				var unitField = ElementUtil.query(toolbarFilter, 'filterTractorId');
				var applyItems = function(items) {
					if (requestId !== lookupRequestId) {
						return;
					}
					unitField.items = items;
					if (selectedUnitId) {
						unitField.value = selectedUnitId;
					}
				};

				if (selectedUnitId) {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnits(refType, {
							max: 1,
							filterField: 'code',
							filterValue: selectedUnitId
						}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};		
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [											
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterTractorId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Tractor',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,					
					postinit: function(combo) {																	
					},
					placeHolder: 'Select',
					listeners: {
						input: {
							fn: function(e) {
								loadReferenceLookup('TRACTOR', e.target.value);	
							},
							buffer: 500
						},
						change: function() {
							actionRefresh();
						}
					}
				},				
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'preview',
					theme: 'primary',
					'class': 'spacer-toolbar-item',										
					children:[
						ElementUtil.makeIcon('vaadin:plus-minus', ' Preview Shifts')						
					],
					listeners: {
						click: function() {
							actionPreviewShift();
						}
					}					
				},	
				{
					tag: 'dl-action-button',
					itemid: 'showMap',
					'class': 'spacer-toolbar-item',
					disabled: true,						
					children:[
						ElementUtil.makeIcon('vaadin:globe', ' Show on Map')						
					],
					listeners: {
						click: function() {
							actionShowMap(grid.selectedItems[0]);
						}
					}					
				},			
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'apply',
							'class': 'spacer-toolbar-item',	
							theme: 'success primary',
							permissions: ['TIME_TOOLS:WRITE'],							
							children:[
								ElementUtil.makeIcon('vaadin:check', ' Apply Shifts')						
							],
							listeners: {
								click: function() {
									actionApplyShift();
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{						
					path: 'recordDts',
					header: 'Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.recordDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'gpsLocation',
					header: 'GPS Location',
					width: '10em',
					renderer: function(root, column, rowData) {
						if (rowData.item.gpsLocation) {
							root.innerHTML = StringUtil.blankIfNull(rowData.item.gpsLocation.addressLine1) + ' ' +
									StringUtil.blankIfNull(rowData.item.gpsLocation.city) + ', ' + 
									StringUtil.blankIfNull(rowData.item.gpsLocation.stateProv) + ' ' + 
									StringUtil.blankIfNull(rowData.item.gpsLocation.country) + '<br>' + 
							StringUtil.blankIfNull(rowData.item.gpsLocation.latitude) + ', ' + 
							StringUtil.blankIfNull(rowData.item.gpsLocation.longitude); 
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'fuelLocation',
					header: 'Fuel Location',
					width: '10em',
					renderer: function(root, column, rowData) {
						if (rowData.item.fuelLocation) {
							root.innerHTML = StringUtil.blankIfNull(rowData.item.fuelLocation.addressLine1) + ' ' +
									StringUtil.blankIfNull(rowData.item.fuelLocation.city) + (rowData.item.fuelLocation.city ? ', ' : '') + 
									StringUtil.blankIfNull(rowData.item.fuelLocation.stateProv) + ' ' + 
									StringUtil.blankIfNull(rowData.item.fuelLocation.country) + '<br>' + 
									StringUtil.blankIfNull(rowData.item.fuelLocation.latitude) + (rowData.item.fuelLocation.latitude ? ', ' : '') + 
									StringUtil.blankIfNull(rowData.item.fuelLocation.longitude); 
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'tripStopLocation',
					header: 'Trip Stop Location',
					width: '10em',
					renderer: function(root, column, rowData) {
						if (rowData.item.tripStopLocation) {
							root.innerHTML = StringUtil.blankIfNull(rowData.item.tripStopLocation.addressLine1) + ' ' +
									StringUtil.blankIfNull(rowData.item.tripStopLocation.city) + ', ' + 
									StringUtil.blankIfNull(rowData.item.tripStopLocation.stateProv) + ' ' + 
									StringUtil.blankIfNull(rowData.item.tripStopLocation.country) + '<br>' + 
									StringUtil.blankIfNull(rowData.item.tripStopLocation.latitude) + ', ' + 
									StringUtil.blankIfNull(rowData.item.tripStopLocation.longitude) + '<br>' +
									StringUtil.blankIfNull(rowData.item.tripRefNo); 
						} else {
							root.innerHTML = '';
						}	
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'showMap').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'showMap').disabled = true;
					}				
										
				}
			}
		});	
		
		timeToolSyncGrid.shifts = {
			gpsShiftHours: 0,
			fuelShiftHours: 0,
			tripShiftHours: 0
		};
	
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
									
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);		
									
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'recordDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							start: startFilterDts,														
							end: endFilterDts,
							dateField: 'recordDts',
							gpsShiftHours: timeToolSyncGrid.shifts.gpsShiftHours,
							fuelShiftHours: timeToolSyncGrid.shifts.fuelShiftHours,
							tripShiftHours: timeToolSyncGrid.shifts.tripShiftHours
						};										
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
													
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();

						};
						
						var tractorId = ElementUtil.query(toolbarFilter, 'filterTractorId').value;
						if (tractorId) {						
							DataManagementService.getTimeToolService().getDataSync(tractorId, grid.currentFilter).then(function(records){
								successHandler(records);
							});						
						} else {
							loadMask.remove();
							if (timeToolSyncGrid.nextLoadOfGrid) {
								ElementUtil.query(toolbarFilter, 'filterTractorId').validate();								
								window.DL.MessageUtil.showToastError('A tractor must be selected');
							} else {
								timeToolSyncGrid.nextLoadOfGrid = true;
							}
						}
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
	
		var statusBar = ElementUtil.create({
			tag: 'div',
			style: 'padding-left: 10px;',
			innerHTML: ''
		});
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				statusBar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});		
	
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		timeToolSyncGrid.append(flexLayout);	
		
		loadReferenceLookup('TRACTOR', '');
			
		var updateShiftStatus = function() {
			var highlight = '';
			if (timeToolSyncGrid.shifts.gpsShiftHours) {
				if (timeToolSyncGrid.shifts.gpsShiftHours !== "0" ||
						timeToolSyncGrid.shifts.fuelShiftHours !== "0" ||
						timeToolSyncGrid.shifts.tripShiftHours !== "0") {
					highlight = 'highlight-background';
				}
			}
						
			statusBar.innerHTML = '<span class="' + highlight + '">Time Shifts GPS: ' + timeToolSyncGrid.shifts.gpsShiftHours + ' | ' + 
					'Fuel: ' + timeToolSyncGrid.shifts.fuelShiftHours + ' | ' +
					'Trip Stop: ' + timeToolSyncGrid.shifts.tripShiftHours + '</span>';			
		};	
		updateShiftStatus();
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(timeToolSyncGrid, toolbarFilter,
			['filterTractorId','filterStartDate','filterEndDate'],
			actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterTractorId'));
					state.filterTractorId = unitState.value;
					state.filterTractorDescription = unitState.description;
				},
				restore: function(data) {
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterTractorId'),
						refType: 'TRACTOR',
						unitId: data.filterTractorId,
						description: data.filterTractorDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								return UnitService.getUnitLookupService().getUnits(referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						actionRefresh();
					});
				}
			});
		
		var actionPreviewShift = function() {
			
			var previewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Preview Shift (Applies TimeShift Temporarily)',
				icon: 'vaadin:clock',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						previewWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [									
										{
											tag: 'vaadin-number-field',										
											name: 'gpsShiftHours',
											label: 'GPS Shift Hours',											
											required: true,
											value: 0,
											min: -2160,
											max: 2160
										},
										{
											tag: 'vaadin-number-field',										
											name: 'fuelShiftHours',
											label: 'Fuel Shift Hours',											
											required: true,
											value: 0,
											min: -2160,
											max: 2160
										},
										{
											tag: 'vaadin-number-field',										
											name: 'tripShiftHours',
											label: 'Trip Shift Hours',											
											required: true,
											value: 0,
											min: -2160,
											max: 2160
										},																				
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:clock', ' Preview Time Shifts')
													],
													listeners: {
														click: function() {															
															
															var data = formPanel.getData();
															
															timeToolSyncGrid.shifts = {
																gpsShiftHours: data.gpsShiftHours,
																fuelShiftHours: data.fuelShiftHours,
																tripShiftHours: data.tripShiftHours
															};
															actionRefresh();
															updateShiftStatus();
															previewWin.close();
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															previewWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						previewWin.addToContentElement(formPanel);
						
					}
				}
			});					
			
		}; 
		
		var actionApplyShift = function() {
			var timeShiftWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Apply Time Shift',
				icon: 'vaadin:clock',
				width: 700,
				height: 400,
				listeners: {
					ready: function () {
						timeShiftWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'dl-unitselection',
											itemId: 'unitSelection',
											properties: {
												showReportOptions: false
											},
											colspan: 2
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Affected Start Date',
											name: 'dataStartDts',
											'helper-text': 'mm/dd/yyyy hh:mm:ss',
											step: 1,
											value: ElementUtil.query(toolbarFilter, 'filterStartDate').value + 'T00:00:00',
											required: true
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Affected End Date',
											'helper-text': 'mm/dd/yyyy hh:mm:ss',
											name: 'dataEndDts',											
											step: 1,
											value: ElementUtil.query(toolbarFilter, 'filterEndDate').value + 'T23:59:59',
											required: true
										},
										{
											tag: 'vaadin-number-field',
											name: 'gpsTimeAdjustHours',
											label: 'GPS Hours to Shift',
											required: true,
											value: timeToolSyncGrid.shifts.gpsShiftHours,
											min: -(24 * 90),
											max: (24 * 90)
										},
										{
											tag: 'vaadin-number-field',
											name: 'fuelTimeAdjustHours',
											label: 'Fuel Hours to Shift',
											required: true,
											value: timeToolSyncGrid.shifts.fuelShiftHours,
											min: -(24 * 90),
											max: (24 * 90)
										},
										{
											tag: 'vaadin-number-field',
											name: 'tripTimeAdjustHours',
											label: 'Trip Hours to Shift',
											required: true,
											value: timeToolSyncGrid.shifts.tripShiftHours,
											min: -(24 * 90),
											max: (24 * 90)
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'overlapHandlingCB',
											label: 'OverLap Handling',
											name: 'overlapHandling',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'FAIL',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TimeShiftHandlingType').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:arrow-right', ' Shift')
													],
													listeners: {
														click: function () {

															if (formPanel.isValid()) {
																var data = formPanel.getData();
																data.unitSelection = ElementUtil.query(formPanel, 'unitSelection').unitSelectionValue();
																
																var handleFail = function(result) {
																	if (result) {
																		var errors = [];
																		for (var key in result.errors) {
																			errors.push(key + " - " + result.errors[key]);
																		}
																		window.DL.MessageUtil.showToastError('Failed to Shift Records.<br>' + errors);
																	}
																};

																var loadMask = formPanel.showLoading('Submitting shift tasks');
																DataManagementService.getTimeToolService().applyTimeshift(data).then(function(result){
																	loadMask.remove();
																	
																	if (result.success) {
																		window.DL.MessageUtil.showToast('Success', 'Add tasks to time shift Records', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		timeShiftWin.close();
																	} else {
																		handleFail(result);	
																	}
																}).catch(function(result) {
																	loadMask.remove();
																	handleFail(result);																	
																});

															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {															
															timeShiftWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});

						timeShiftWin.addToContentElement(formPanel);

					}
				}
			});
		};
		
		var actionShowMap = function(record) {
			var date = TimeUtil.parseDate(record.recordDts);			
			var mapWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Map - ' + TimeUtil.formatDateStandard(date),
				icon: 'vaadin:globe',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						mapWin.show();
						
						var map = ElementUtil.create({
							tag: 'dl-map-panel',
							slot: 'primary',
							style: 'width: 100%; height: 100%'
						});

						var mapFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								map				
							]
						});	
						
						mapWin.addToContentElement(mapFlexLayout);
						
						setTimeout(function(){
								
							//handle lat/long; address, city, state; city, state;  state (state pin)	
							var mapable = [];
							var notMappable = [];
							var addLocation = function(location) {
								if (location) {
									if (location.longitude && location.latitude) {
										mapable.push(location);
									} else if (location.stateProv && location.country) {
										var latLong = map.stateCountryToLatLong(location.stateProv, location.country);
										if (latLong) {
											mapable.push({
												latitude: latLong.lat,
												longitude: latLong.long,
												stateProv: location.stateProv,
												country: location.country
											});
										} else {
											notMappable.push(location);
										}
									} else {
										notMappable.push(location);
									}
								}
							};
							addLocation(record.gpsLocation);
							addLocation(record.fuelLocation);
							addLocation(record.tripStopLocation);							
							
							if (notMappable.length > 0) {
								window.DL.MessageUtil.showToast(notMappable.length + ' location(s) are unable to be mapped.<br> Missing detailed location information.');
							}
								
							mapable.forEach(function(mapPoint){
								var longLats = [mapPoint.longitude, mapPoint.latitude];
								
								var info = StringUtil.blankIfNull(mapPoint.addressLine1) + ' ' + 
										StringUtil.blankIfNull(mapPoint.city) + (mapPoint.city ? ', ' : '') + mapPoint.stateProv + ' ' + 
										mapPoint.country + '<br>'
										+ mapPoint.latitude + ', ' + mapPoint.longitude;

								map.addMarker(longLats, {
									popupHTML: info
								});
							});

							if (mapable.length === 1) {
								setTimeout(function() {
									map.zoomOnPoint([
										mapable[0].longitude,
										mapable[0].latitude
									]);
								}, 1000);
							}
							
						}, 200);						

					}
				}
			});
		};
		
	}

}
customElements.define('dl-timetool-sync-grid', TimeToolSyncGrid);
